import type { DeviceBenchmark } from '../types/solver'

export async function runBrowserBenchmark(): Promise<Omit<DeviceBenchmark, 'riverSolveMs' | 'indexedDbMs'>> {
  let typedArrayMb = 0
  for (const sizeMb of [8, 16, 32, 64]) {
    try {
      const array = new Uint8Array(sizeMb * 1024 * 1024)
      for (let index = 0; index < array.length; index += 4096) array[index] = index & 255
      typedArrayMb = sizeMb
    } catch {
      break
    }
    await new Promise((resolve) => setTimeout(resolve, 0))
  }

  return {
    id: crypto.randomUUID(),
    createdAt: new Date().toISOString(),
    userAgent: navigator.userAgent,
    wasm: typeof WebAssembly === 'object',
    worker: typeof Worker === 'function',
    sharedArrayBuffer: typeof SharedArrayBuffer === 'function' && crossOriginIsolated,
    wakeLock: 'wakeLock' in navigator,
    typedArrayMb,
    recommendedMode: 'single-thread',
  }
}
